import { Link } from "react-router-dom";
import MarketingHeader from "@/components/layout/MarketingHeader";
import MarketingFooter from "@/components/layout/MarketingFooter";
import { Check } from "lucide-react";

const FEATURES = [
  "Unlimited bills and income entries",
  "Weekly, biweekly, and monthly pay periods",
  "Automatic carryover for unpaid balances",
  "Safe / Tight / Short status at a glance",
  "End-of-month cash projection",
  "Multiple funding sources (bills card, debit, cash)",
  "Sample demo data to try before you commit",
  "Cancel anytime from your subscription page",
];

export default function Pricing() {
  return (
    <div className="min-h-screen" data-testid="marketing-pricing">
      <MarketingHeader />
      <section className="max-w-4xl mx-auto px-6 md:px-8 py-20 text-center">
        <div className="text-xs font-semibold uppercase tracking-widest text-[#8A918D] mb-3">Simple pricing</div>
        <h1 className="font-heading text-4xl md:text-5xl font-light tracking-tight text-[#2C302E]">
          One plan. One month free.
        </h1>
        <p className="mt-6 text-lg text-[#59605C] max-w-xl mx-auto">
          Try What&rsquo;s Your Balance? for 30 days. Then $9.99/month. Cancel anytime.
        </p>

        <div className="mt-14 grid md:grid-cols-2 gap-6 text-left">
          <div className="card-soft p-8">
            <div className="text-xs font-semibold uppercase tracking-widest text-[#8A918D]">Free trial</div>
            <div className="mt-2 font-heading text-3xl font-medium text-[#2C302E]">$0<span className="text-base text-[#8A918D] font-normal"> · 30 days</span></div>
            <p className="mt-4 text-[#59605C]">Full access. No card required to start. Great for one full paycheck cycle.</p>
            <Link to="/signup" data-testid="pricing-signup-free" className="btn-secondary mt-6 w-full">
              Start free trial
            </Link>
          </div>
          <div className="card-soft p-8 border-2 border-[#8BA888]">
            <div className="text-xs font-semibold uppercase tracking-widest text-[#3B5B3E]">Monthly</div>
            <div className="mt-2 font-heading text-3xl font-medium text-[#2C302E]">$9.99<span className="text-base text-[#8A918D] font-normal">/month</span></div>
            <p className="mt-4 text-[#59605C]">Everything you need to survive between paychecks. Cancel any time.</p>
            <ul className="mt-6 space-y-2.5">
              {FEATURES.map((f) => (
                <li key={f} className="flex items-start gap-2 text-[#2C302E] text-sm">
                  <Check size={16} className="text-[#4A6148] mt-1 shrink-0" />
                  {f}
                </li>
              ))}
            </ul>
            <Link to="/signup" data-testid="pricing-signup-paid" className="btn-primary mt-8 w-full">
              Start free trial
            </Link>
          </div>
        </div>

        <p className="mt-10 text-sm text-[#8A918D]">
          Prices in USD. You’ll only be charged after your 30-day trial ends.
        </p>
      </section>
      <MarketingFooter />
    </div>
  );
}
